import { useState, forwardRef, useCallback } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

const iconWrapperStyle = {
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
};

const iconStyle = {
    fontSize: "35px",
    color: "#fff",
};

/* Custom icon button */
const CalendarIcon = forwardRef((props, ref) => {
    const { onClick } = props;

    return (
        <span
            ref={ref}
            onClick={onClick}
            style={iconWrapperStyle}
            className="me-3"
        >
            <i className="material-icons" style={iconStyle}>
                calendar_month
            </i>
        </span>
    );
});

CalendarIcon.displayName = "CalendarIcon";

const DateRangeFilter = ({ onChange }) => {
    const [range, setRange] = useState([null, null]);
    const [startDate, endDate] = range;

    const handleChange = useCallback(
        (dates) => {
            setRange(dates);
            const [start, end] = dates;

            if (start && end && onChange) {
                onChange({
                    startDate: format(start, "yyyy-MM-dd"),
                    endDate: format(end, "yyyy-MM-dd"),
                });
            }
        },
        [onChange]
    );

    return (
        <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={handleChange}
            customInput={<CalendarIcon />}
            popperPlacement="bottom-end"
        />
    );
};

export default DateRangeFilter;